import styled from "styled-components";
import { DESKTOP } from "common/constants/breakpoints";

interface StandardButtonProps {
  selected?: boolean;
  secondary?: boolean;
}

export default styled.button<StandardButtonProps>`
  flex: 1;
  outline: none;
  border-style: solid;
  border-width: 2px;
  border-color: ${({ selected }) => (selected ? "#ffffff" : "transparent")};
  margin: 0;
  padding: 17px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ secondary, selected }) =>
    secondary ? "#c0d72c" : selected ? "#17426e" : "#306ba5"};
  color: #ffffff;
  font-size: 18px;
  font-weight: 400;

  &:hover {
    background-color: ${({ secondary, selected }) =>
      secondary ? "#cbda69" : selected ? "#265c92" : "#4b86c0"};
  }

  &:active {
    background-color: ${({ secondary }) => (secondary ? "#a6be0a" : "#1a5690")};
  }

  &:disabled {
    background-color: ${({ secondary }) => (secondary ? "#c2c3c3" : "#c2c3c4")};
  }

  @media screen and (min-width: ${DESKTOP}px) {
    font-size: 16px;
    cursor: pointer;
  }
`;
